import { Campaign } from 'modules/domains/campaign';
import { LastModifiedCell, UserInfo } from 'ui/indexPages/tables/cells';
import { isCampaignValid } from 'modules/experiments/utils';
import { useExperimentTakeover } from 'modules/experiments/takeover/hooks';
import { ExperimentTakeoverSource } from 'modules/experiments/takeover/constants';
import { useExperimentsTranslations } from 'modules/experiments/hooks';

import {
  BaseCell,
  StatusCell,
  CampaignNameCell,
  ExperimentNameCell,
  ChooseCampaignCell,
  IdCell,
} from './cells';
import { CellPadding, InPageGridRow } from '../styled';

export const DataRow = ({ campaign, tableGrid }: { campaign: Campaign; tableGrid: any }) => {
  const {
    id,
    name,
    campaignState,
    campaignTypeDefinition,
    messageMedium,
    experiments,
    createdBy,
    createdAt,
    updatedAt: modifiedAt,
    creatorUser,
  } = campaign;
  const latestExperiment = experiments?.[0];

  const { ct, t } = useExperimentsTranslations();
  // Derived data
  const createdByUser: UserInfo = { emailAddress: createdBy || '', ...creatorUser };

  const { isValidCampaign, ruleViolation } = isCampaignValid({
    campaignState,
    campaignTypeDefinition,
    experiments,
  });

  // Edit experiment takeover trigger
  const { getExperimentLinkAttributes } = useExperimentTakeover();
  const { href = '#' } = getExperimentLinkAttributes({
    source: ExperimentTakeoverSource.EXPERIMENT_INDEX_CHOOSE_CAMPAIGN_TAKEOVER,
    experiment: latestExperiment,
    campaign,
  });

  // Labels
  const campaignTypeLabel = t(`campaignTypes.${campaignTypeDefinition}`);
  const messageMediumLabel = ct(`labels.mediums.${messageMedium}`);

  return (
    <InPageGridRow gridLayout={tableGrid}>
      <IdCell value={id.toString()} isDisabled={!isValidCampaign} />
      <CampaignNameCell name={name} id={id} state={campaignState} />
      <StatusCell campaignState={campaignState} />
      <BaseCell value={campaignTypeLabel} />
      <BaseCell value={messageMediumLabel} />
      <ExperimentNameCell
        experimentName={latestExperiment?.name}
        experimentState={latestExperiment?.state}
        href={href}
      />
      <CellPadding>
        <LastModifiedCell createdBy={createdByUser} createdAt={createdAt} modifiedAt={modifiedAt} />
      </CellPadding>
      <ChooseCampaignCell
        isDisabled={!isValidCampaign}
        ruleViolation={ruleViolation}
        id={id}
        campaignState={campaignState}
      />
    </InPageGridRow>
  );
};
